/**
 * SEO Data for all pages
 * Centralized SEO meta tags, titles, and descriptions
 */

export interface PageSEO {
    title: string;
    description: string;
    keywords?: string;
    canonical?: string;
}

export const seoData: Record<string, PageSEO> = {
    // Home
    home: {
        title: 'Clínica Dr. Guilherme Galvão — Osteopatia e Fisioterapia | Tratamento da Dor',
        description: 'Clínica especializada em Osteopatia e Fisioterapia em Ermesinde. Tratamento da dor com abordagem integrada e personalizada. Marque a sua consulta.',
        keywords: 'osteopatia ermesinde, fisioterapia ermesinde, tratamento dor, quiropraxia, massagem desportiva, auriculoterapia, alinhamento postural, ventosaterapia',
        canonical: 'https://www.clinicaosteopatia.pt/'
    },

    // Contact
    contact: {
        title: 'Contacto — Clínica Dr. Guilherme Galvão | Marque a Sua Consulta',
        description: 'Contacte a Clínica Dr. Guilherme Galvão em Ermesinde. Telefone, email e formulário de contacto. Marque a sua consulta de osteopatia ou fisioterapia.',
        keywords: 'contacto clínica osteopatia, marcar consulta ermesinde, telefone clínica osteopatia',
        canonical: 'https://www.clinicaosteopatia.pt/contact'
    },

    // Clinic Pages
    aboutUs: {
        title: 'Sobre Nós — Clínica Dr. Guilherme Galvão | A Nossa História',
        description: 'Conheça a Clínica Dr. Guilherme Galvão. Especialistas em osteopatia e fisioterapia com anos de experiência no tratamento da dor e bem-estar.',
        keywords: 'sobre clínica osteopatia, história clínica, equipa osteopatia ermesinde',
        canonical: 'https://www.clinicaosteopatia.pt/clinic/about-us'
    },
    gallery: {
        title: 'Galeria — Clínica Dr. Guilherme Galvão | As Nossas Instalações',
        description: 'Conheça as instalações da Clínica Dr. Guilherme Galvão. Ambiente moderno e acolhedor para o seu tratamento de osteopatia e fisioterapia.',
        keywords: 'galeria clínica, instalações osteopatia, fotos clínica ermesinde',
        canonical: 'https://www.clinicaosteopatia.pt/clinic/gallery'
    },
    location: {
        title: 'Localização — Clínica Dr. Guilherme Galvão | Como Chegar',
        description: 'Localização da Clínica Dr. Guilherme Galvão em Ermesinde. Morada, horários e como chegar. Estacionamento disponível.',
        keywords: 'localização clínica osteopatia, morada clínica ermesinde, como chegar clínica',
        canonical: 'https://www.clinicaosteopatia.pt/clinic/location'
    },
    arbitration: {
        title: 'Centro de Arbitragem — Clínica Dr. Guilherme Galvão',
        description: 'Informações sobre o centro de arbitragem da Clínica Dr. Guilherme Galvão. Resolução de conflitos e reclamações.',
        canonical: 'https://www.clinicaosteopatia.pt/clinic/arbitration'
    },
    termos: {
        title: 'Termos e Condições — Clínica Dr. Guilherme Galvão',
        description: 'Termos e condições de utilização do website da Clínica Dr. Guilherme Galvão.',
        canonical: 'https://www.clinicaosteopatia.pt/clinic/termos'
    },
    privacy: {
        title: 'Política de Privacidade — Clínica Dr. Guilherme Galvão',
        description: 'Política de privacidade e proteção de dados da Clínica Dr. Guilherme Galvão.',
        canonical: 'https://www.clinicaosteopatia.pt/clinic/privacy'
    },
    cookies: {
        title: 'Política de Cookies — Clínica Dr. Guilherme Galvão',
        description: 'Política de cookies do website da Clínica Dr. Guilherme Galvão. Saiba como utilizamos cookies.',
        canonical: 'https://www.clinicaosteopatia.pt/clinic/cookies'
    },

    // Service Pages
    osteopathy: {
        title: 'Osteopatia em Ermesinde — Clínica Dr. Guilherme Galvão | Tratamento Manual',
        description: 'Osteopatia em Ermesinde. Tratamento manual para dores musculares, articulares e problemas posturais. Técnicas especializadas e personalizadas.',
        keywords: 'osteopatia ermesinde, tratamento osteopático, osteopata ermesinde, dores musculares, dores articulares',
        canonical: 'https://www.clinicaosteopatia.pt/services/osteopathy'
    },
    physiotherapy: {
        title: 'Fisioterapia em Ermesinde — Clínica Dr. Guilherme Galvão | Reabilitação',
        description: 'Fisioterapia em Ermesinde. Reabilitação funcional, tratamento de lesões e recuperação pós-cirúrgica. Técnicas modernas e eficazes.',
        keywords: 'fisioterapia ermesinde, fisioterapeuta ermesinde, reabilitação, tratamento lesões',
        canonical: 'https://www.clinicaosteopatia.pt/services/physiotherapy'
    },
    chiropractic: {
        title: 'Quiropraxia em Ermesinde — Clínica Dr. Guilherme Galvão | Ajustes Vertebrais',
        description: 'Quiropraxia em Ermesinde. Ajustes vertebrais e tratamento de problemas da coluna. Alívio de dores nas costas e pescoço.',
        keywords: 'quiropraxia ermesinde, quiroprático ermesinde, ajustes vertebrais, dores coluna',
        canonical: 'https://www.clinicaosteopatia.pt/services/chiropractic'
    },
    sportsMassage: {
        title: 'Massagem Desportiva em Ermesinde — Clínica Dr. Guilherme Galvão',
        description: 'Massagem desportiva em Ermesinde. Preparação e recuperação muscular para atletas. Melhore o seu desempenho e previna lesões.',
        keywords: 'massagem desportiva ermesinde, massagem atletas, recuperação muscular',
        canonical: 'https://www.clinicaosteopatia.pt/services/sports-massage'
    },
    painTreatment: {
        title: 'Tratamento da Dor em Ermesinde — Clínica Dr. Guilherme Galvão',
        description: 'Tratamento da dor em Ermesinde. Abordagem integrada para dores crónicas e agudas. Alívio eficaz e duradouro.',
        keywords: 'tratamento dor ermesinde, dores crónicas, alívio dor, gestão dor',
        canonical: 'https://www.clinicaosteopatia.pt/services/pain-treatment'
    },
    auriculotherapy: {
        title: 'Auriculoterapia em Ermesinde — Clínica Dr. Guilherme Galvão | Acupuntura Auricular',
        description: 'Auriculoterapia em Ermesinde. Tratamento através de pontos específicos da orelha. Técnica complementar eficaz para diversas condições.',
        keywords: 'auriculoterapia ermesinde, acupuntura auricular, pontos orelha',
        canonical: 'https://www.clinicaosteopatia.pt/services/auriculotherapy'
    },
    posturalAlignment: {
        title: 'Alinhamento Postural em Ermesinde — Clínica Dr. Guilherme Galvão',
        description: 'Alinhamento postural em Ermesinde. Correção de postura e prevenção de dores. Avaliação e tratamento personalizado.',
        keywords: 'alinhamento postural ermesinde, correção postura, problemas posturais',
        canonical: 'https://www.clinicaosteopatia.pt/services/postural-alignment'
    },
    cuppingTherapy: {
        title: 'Ventosaterapia em Ermesinde — Clínica Dr. Guilherme Galvão | Terapia com Ventosas',
        description: 'Ventosaterapia em Ermesinde. Tratamento com ventosas para alívio de dores musculares e melhoria da circulação. Técnica milenar eficaz.',
        keywords: 'ventosaterapia ermesinde, terapia ventosas, ventosas medicina tradicional',
        canonical: 'https://www.clinicaosteopatia.pt/services/cupping-therapy'
    }
};

/**
 * Get SEO data for a service page
 */
export const getServiceSEO = (serviceSlug: string): PageSEO => {
    return seoData[serviceSlug] || seoData.home;
};

